function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillOpacity: 0.246,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#212121"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.75 16c.138 0 .25.112.25.25v2.5c0 .138-.112.25-.25.25H2.25c-.138 0-.25-.112-.25-.25v-2.5c0-.138.112-.25.25-.25h19.5zm0-6c.138 0 .25.112.25.25v2.5c0 .138-.112.25-.25.25H2.25c-.138 0-.25-.112-.25-.25v-2.5c0-.138.112-.25.25-.25h19.5zm0-6c.138 0 .25.112.25.25v2.5c0 .138-.112.25-.25.25H2.25C2.112 7 2 6.888 2 6.75v-2.5c0-.138.112-.25.25-.25h19.5z",
  transform: "translate(-183 -209) translate(183 209)"
})));

var SvgBurgerIcon = function SvgBurgerIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBurgerIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/burgerIcon.6ac8206b.svg";
export { ForwardRef as ReactComponent };